



//*************  Beispiel für Socket.io:    https://deepinder.me/creating-a-real-time-chat-app-with-vue-socket-io-and-nodejs */


//*****************************  socket param auch anpassen !!!!!!!!!!  (Datei: socket_param.env)    ) */



module.exports.config_server_adresse = {

    
// url : 'http://localhost:1416/api/',   //  ***** API-Anwendung
// url_foto_upload:'http://localhost:1414/upload',  //  ***** Hauptanwendung
// url_foto_anzeigen:'http://localhost:1414/uploader'  //  ***** Hauptanwendung
// 

//////################  package.json  die Versionsnummer ändern, damit Browser Dateien neu lädt!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!####################################


    url : 'https://hlm-api.tech-manager.online/api/',
    url_foto_upload:'https://hlm.tech-manager.online/upload',  //  ***** Hauptanwendung Fotos hochladen
    url_foto_anzeigen:'https://hlm.tech-manager.online/uploader'  //  ***** Hauptanwendung Fotos anzeigen


};